/** French departments for Select dropdowns */
export const DEPARTMENTS: { value: string; label: string }[] = [
  { value: '01', label: '01 - Ain' },
  { value: '02', label: '02 - Aisne' },
  { value: '03', label: '03 - Allier' },
  { value: '04', label: '04 - Alpes-de-Haute-Provence' },
  { value: '05', label: '05 - Hautes-Alpes' },
  { value: '06', label: '06 - Alpes-Maritimes' },
  { value: '07', label: '07 - Ardeche' },
  { value: '08', label: '08 - Ardennes' },
  { value: '09', label: '09 - Ariege' },
  { value: '10', label: '10 - Aube' },
  { value: '11', label: '11 - Aude' },
  { value: '12', label: '12 - Aveyron' },
  { value: '13', label: '13 - Bouches-du-Rhone' },
  { value: '14', label: '14 - Calvados' },
  { value: '15', label: '15 - Cantal' },
  { value: '16', label: '16 - Charente' },
  { value: '17', label: '17 - Charente-Maritime' },
  { value: '18', label: '18 - Cher' },
  { value: '19', label: '19 - Correze' },
  { value: '2A', label: '2A - Corse-du-Sud' },
  { value: '2B', label: '2B - Haute-Corse' },
  { value: '21', label: '21 - Cote-d\'Or' },
  { value: '22', label: '22 - Cotes-d\'Armor' },
  { value: '23', label: '23 - Creuse' },
  { value: '24', label: '24 - Dordogne' },
  { value: '25', label: '25 - Doubs' },
  { value: '26', label: '26 - Drome' },
  { value: '27', label: '27 - Eure' },
  { value: '28', label: '28 - Eure-et-Loir' },
  { value: '29', label: '29 - Finistere' },
  { value: '30', label: '30 - Gard' },
  { value: '31', label: '31 - Haute-Garonne' },
  { value: '32', label: '32 - Gers' },
  { value: '33', label: '33 - Gironde' },
  { value: '34', label: '34 - Herault' },
  { value: '35', label: '35 - Ille-et-Vilaine' },
  { value: '36', label: '36 - Indre' },
  { value: '37', label: '37 - Indre-et-Loire' },
  { value: '38', label: '38 - Isere' },
  { value: '39', label: '39 - Jura' },
  { value: '40', label: '40 - Landes' },
  { value: '41', label: '41 - Loir-et-Cher' },
  { value: '42', label: '42 - Loire' },
  { value: '43', label: '43 - Haute-Loire' },
  { value: '44', label: '44 - Loire-Atlantique' },
  { value: '45', label: '45 - Loiret' },
  { value: '46', label: '46 - Lot' },
  { value: '47', label: '47 - Lot-et-Garonne' },
  { value: '48', label: '48 - Lozere' },
  { value: '49', label: '49 - Maine-et-Loire' },
  { value: '50', label: '50 - Manche' },
  { value: '51', label: '51 - Marne' },
  { value: '52', label: '52 - Haute-Marne' },
  { value: '53', label: '53 - Mayenne' },
  { value: '54', label: '54 - Meurthe-et-Moselle' },
  { value: '55', label: '55 - Meuse' },
  { value: '56', label: '56 - Morbihan' },
  { value: '57', label: '57 - Moselle' },
  { value: '58', label: '58 - Nievre' },
  { value: '59', label: '59 - Nord' },
  { value: '60', label: '60 - Oise' },
  { value: '61', label: '61 - Orne' },
  { value: '62', label: '62 - Pas-de-Calais' },
  { value: '63', label: '63 - Puy-de-Dome' },
  { value: '64', label: '64 - Pyrenees-Atlantiques' },
  { value: '65', label: '65 - Hautes-Pyrenees' },
  { value: '66', label: '66 - Pyrenees-Orientales' },
  { value: '67', label: '67 - Bas-Rhin' },
  { value: '68', label: '68 - Haut-Rhin' },
  { value: '69', label: '69 - Rhone' },
  { value: '70', label: '70 - Haute-Saone' },
  { value: '71', label: '71 - Saone-et-Loire' },
  { value: '72', label: '72 - Sarthe' },
  { value: '73', label: '73 - Savoie' },
  { value: '74', label: '74 - Haute-Savoie' },
  { value: '75', label: '75 - Paris' },
  { value: '76', label: '76 - Seine-Maritime' },
  { value: '77', label: '77 - Seine-et-Marne' },
  { value: '78', label: '78 - Yvelines' },
  { value: '79', label: '79 - Deux-Sevres' },
  { value: '80', label: '80 - Somme' },
  { value: '81', label: '81 - Tarn' },
  { value: '82', label: '82 - Tarn-et-Garonne' },
  { value: '83', label: '83 - Var' },
  { value: '84', label: '84 - Vaucluse' },
  { value: '85', label: '85 - Vendee' },
  { value: '86', label: '86 - Vienne' },
  { value: '87', label: '87 - Haute-Vienne' },
  { value: '88', label: '88 - Vosges' },
  { value: '89', label: '89 - Yonne' },
  { value: '90', label: '90 - Territoire de Belfort' },
  { value: '91', label: '91 - Essonne' },
  { value: '92', label: '92 - Hauts-de-Seine' },
  { value: '93', label: '93 - Seine-Saint-Denis' },
  { value: '94', label: '94 - Val-de-Marne' },
  { value: '95', label: '95 - Val-d\'Oise' },
  { value: '971', label: '971 - Guadeloupe' },
  { value: '972', label: '972 - Martinique' },
  { value: '973', label: '973 - Guyane' },
  { value: '974', label: '974 - La Reunion' },
  { value: '975', label: '975 - Saint-Pierre-et-Miquelon' },
  { value: '976', label: '976 - Mayotte' },
];

/** Countries for Select dropdowns (most common first) */
export const COUNTRIES: { value: string; label: string }[] = [
  { value: 'FRA', label: 'France' },
  { value: 'BEL', label: 'Belgique' },
  { value: 'LUX', label: 'Luxembourg' },
  { value: 'DEU', label: 'Allemagne' },
  { value: 'ESP', label: 'Espagne' },
  { value: 'ITA', label: 'Italie' },
  { value: 'NLD', label: 'Pays-Bas' },
  { value: 'GBR', label: 'Royaume-Uni' },
  { value: 'CHE', label: 'Suisse' },
  { value: 'PRT', label: 'Portugal' },
  { value: 'AUT', label: 'Autriche' },
  { value: 'POL', label: 'Pologne' },
  { value: 'CZE', label: 'Republique Tcheque' },
  { value: 'DNK', label: 'Danemark' },
  { value: 'SWE', label: 'Suede' },
  { value: 'NOR', label: 'Norvege' },
  { value: 'FIN', label: 'Finlande' },
  { value: 'IRL', label: 'Irlande' },
  { value: 'GRC', label: 'Grece' },
  { value: 'HUN', label: 'Hongrie' },
  { value: 'ROU', label: 'Roumanie' },
  { value: 'BGR', label: 'Bulgarie' },
  { value: 'HRV', label: 'Croatie' },
  { value: 'SVN', label: 'Slovenie' },
  { value: 'SVK', label: 'Slovaquie' },
  { value: 'EST', label: 'Estonie' },
  { value: 'LVA', label: 'Lettonie' },
  { value: 'LTU', label: 'Lituanie' },
  { value: 'MLT', label: 'Malte' },
  { value: 'CYP', label: 'Chypre' },
  { value: 'TUR', label: 'Turquie' },
  { value: 'MAR', label: 'Maroc' },
  { value: 'DZA', label: 'Algerie' },
  { value: 'TUN', label: 'Tunisie' },
  { value: 'USA', label: 'Etats-Unis' },
  { value: 'CAN', label: 'Canada' },
  { value: 'CHN', label: 'Chine' },
  { value: 'JPN', label: 'Japon' },
  { value: 'AUS', label: 'Australie' },
  { value: 'BRA', label: 'Bresil' },
];

/** ISO 3166-1 alpha-2 → alpha-3 pour les pays de `COUNTRIES` (fichiers clients : « PL », « FR »…). */
export const COUNTRY_ISO2_TO_ISO3: Readonly<Record<string, string>> = {
  FR: 'FRA', BE: 'BEL', LU: 'LUX', DE: 'DEU', ES: 'ESP', IT: 'ITA', NL: 'NLD', GB: 'GBR', UK: 'GBR', CH: 'CHE',
  PT: 'PRT', AT: 'AUT', PL: 'POL', CZ: 'CZE', DK: 'DNK', SE: 'SWE', NO: 'NOR', FI: 'FIN', IE: 'IRL', GR: 'GRC',
  HU: 'HUN', RO: 'ROU', BG: 'BGR', HR: 'HRV', SI: 'SVN', SK: 'SVK', EE: 'EST', LV: 'LVA', LT: 'LTU', MT: 'MLT',
  CY: 'CYP', TR: 'TUR', MA: 'MAR', DZ: 'DZA', TN: 'TUN', US: 'USA', CA: 'CAN', CN: 'CHN', JP: 'JPN', AU: 'AUS',
  BR: 'BRA',
};

/**
 * French NUTS region names — NUTS1 (current macro-regions), NUTS2 (former
 * regions) and NUTS3 (departments). All three tiers follow the standard
 * Eurostat (NUTS 2021) code→name mapping. The editable label table loaded at
 * startup (see setDynamicNutsLabels) takes priority, so any geocoder code that
 * deviates from this baseline can be corrected per company without a code change.
 */
export const NUTS_REGION_LABELS: Record<string, string> = {
  // NUTS1 — régions actuelles
  FR1: 'Île-de-France',
  FRB: 'Centre-Val de Loire',
  FRC: 'Bourgogne-Franche-Comté',
  FRD: 'Normandie',
  FRE: 'Hauts-de-France',
  FRF: 'Grand Est',
  FRG: 'Pays de la Loire',
  FRH: 'Bretagne',
  FRI: 'Nouvelle-Aquitaine',
  FRJ: 'Occitanie',
  FRK: 'Auvergne-Rhône-Alpes',
  FRL: "Provence-Alpes-Côte d'Azur",
  FRM: 'Corse',
  FRY: 'Outre-mer',
  // NUTS2 — anciennes régions / subdivisions
  FR10: 'Île-de-France',
  FRB0: 'Centre-Val de Loire',
  FRC1: 'Bourgogne',
  FRC2: 'Franche-Comté',
  FRD1: 'Basse-Normandie',
  FRD2: 'Haute-Normandie',
  FRE1: 'Nord-Pas-de-Calais',
  FRE2: 'Picardie',
  FRF1: 'Alsace',
  FRF2: 'Champagne-Ardenne',
  FRF3: 'Lorraine',
  FRG0: 'Pays de la Loire',
  FRH0: 'Bretagne',
  FRI1: 'Limousin',
  FRI2: 'Aquitaine',
  FRI3: 'Poitou-Charentes',
  FRJ1: 'Languedoc-Roussillon',
  FRJ2: 'Midi-Pyrénées',
  FRK1: 'Auvergne',
  FRK2: 'Rhône-Alpes',
  FRL0: "Provence-Alpes-Côte d'Azur",
  FRM0: 'Corse',
  FRY1: 'Guadeloupe',
  FRY2: 'Martinique',
  FRY3: 'Guyane',
  FRY4: 'La Réunion',
  FRY5: 'Mayotte',
  // NUTS3 — départements (classification Eurostat NUTS 2021). Le code dépt.
  // est indiqué en commentaire pour vérification.
  // Île-de-France
  FR101: 'Paris',                    // 75
  FR102: 'Seine-et-Marne',           // 77
  FR103: 'Yvelines',                 // 78
  FR104: 'Essonne',                  // 91
  FR105: 'Hauts-de-Seine',           // 92
  FR106: 'Seine-Saint-Denis',        // 93
  FR107: 'Val-de-Marne',             // 94
  FR108: "Val-d'Oise",               // 95
  // Centre-Val de Loire
  FRB01: 'Cher',                     // 18
  FRB02: 'Eure-et-Loir',             // 28
  FRB03: 'Indre',                    // 36
  FRB04: 'Indre-et-Loire',           // 37
  FRB05: 'Loir-et-Cher',             // 41
  FRB06: 'Loiret',                   // 45
  // Bourgogne
  FRC11: "Côte-d'Or",                // 21
  FRC12: 'Nièvre',                   // 58
  FRC13: 'Saône-et-Loire',           // 71
  FRC14: 'Yonne',                    // 89
  // Franche-Comté
  FRC21: 'Doubs',                    // 25
  FRC22: 'Jura',                     // 39
  FRC23: 'Haute-Saône',              // 70
  FRC24: 'Territoire de Belfort',    // 90
  // Basse-Normandie
  FRD11: 'Calvados',                 // 14
  FRD12: 'Manche',                   // 50
  FRD13: 'Orne',                     // 61
  // Haute-Normandie
  FRD21: 'Eure',                     // 27
  FRD22: 'Seine-Maritime',           // 76
  // Nord-Pas-de-Calais
  FRE11: 'Nord',                     // 59
  FRE12: 'Pas-de-Calais',            // 62
  // Picardie
  FRE21: 'Aisne',                    // 02
  FRE22: 'Oise',                     // 60
  FRE23: 'Somme',                    // 80
  // Alsace
  FRF11: 'Bas-Rhin',                 // 67
  FRF12: 'Haut-Rhin',                // 68
  // Champagne-Ardenne
  FRF21: 'Ardennes',                 // 08
  FRF22: 'Aube',                     // 10
  FRF23: 'Marne',                    // 51
  FRF24: 'Haute-Marne',              // 52
  // Lorraine
  FRF31: 'Meurthe-et-Moselle',       // 54
  FRF32: 'Meuse',                    // 55
  FRF33: 'Moselle',                  // 57
  FRF34: 'Vosges',                   // 88
  // Pays de la Loire
  FRG01: 'Loire-Atlantique',         // 44
  FRG02: 'Maine-et-Loire',           // 49
  FRG03: 'Mayenne',                  // 53
  FRG04: 'Sarthe',                   // 72
  FRG05: 'Vendée',                   // 85
  // Bretagne
  FRH01: "Côtes-d'Armor",            // 22
  FRH02: 'Finistère',                // 29
  FRH03: 'Ille-et-Vilaine',          // 35
  FRH04: 'Morbihan',                 // 56
  // Limousin
  FRI11: 'Corrèze',                  // 19
  FRI12: 'Creuse',                   // 23
  FRI13: 'Haute-Vienne',             // 87
  // Aquitaine
  FRI21: 'Dordogne',                 // 24
  FRI22: 'Gironde',                  // 33
  FRI23: 'Landes',                   // 40
  FRI24: 'Lot-et-Garonne',           // 47
  FRI25: 'Pyrénées-Atlantiques',     // 64
  // Poitou-Charentes
  FRI31: 'Charente',                 // 16
  FRI32: 'Charente-Maritime',        // 17
  FRI33: 'Deux-Sèvres',              // 79
  FRI34: 'Vienne',                   // 86
  // Languedoc-Roussillon
  FRJ11: 'Aude',                     // 11
  FRJ12: 'Gard',                     // 30
  FRJ13: 'Hérault',                  // 34
  FRJ14: 'Lozère',                   // 48
  FRJ15: 'Pyrénées-Orientales',      // 66
  // Midi-Pyrénées
  FRJ21: 'Ariège',                   // 09
  FRJ22: 'Aveyron',                  // 12
  FRJ23: 'Haute-Garonne',            // 31
  FRJ24: 'Gers',                     // 32
  FRJ25: 'Lot',                      // 46
  FRJ26: 'Hautes-Pyrénées',          // 65
  FRJ27: 'Tarn',                     // 81
  FRJ28: 'Tarn-et-Garonne',          // 82
  // Auvergne
  FRK11: 'Allier',                   // 03
  FRK12: 'Cantal',                   // 15
  FRK13: 'Haute-Loire',              // 43
  FRK14: 'Puy-de-Dôme',              // 63
  // Rhône-Alpes
  FRK21: 'Ain',                      // 01
  FRK22: 'Ardèche',                  // 07
  FRK23: 'Drôme',                    // 26
  FRK24: 'Isère',                    // 38
  FRK25: 'Loire',                    // 42
  FRK26: 'Rhône',                    // 69
  FRK27: 'Savoie',                   // 73
  FRK28: 'Haute-Savoie',             // 74
  // Provence-Alpes-Côte d'Azur
  FRL01: 'Alpes-de-Haute-Provence',  // 04
  FRL02: 'Hautes-Alpes',             // 05
  FRL03: 'Alpes-Maritimes',          // 06
  FRL04: 'Bouches-du-Rhône',         // 13
  FRL05: 'Var',                      // 83
  FRL06: 'Vaucluse',                 // 84
  // Corse
  FRM01: 'Corse-du-Sud',             // 2A
  FRM02: 'Haute-Corse',              // 2B
  // Outre-mer
  FRY10: 'Guadeloupe',               // 971
  FRY20: 'Martinique',               // 972
  FRY30: 'Guyane',                   // 973
  FRY40: 'La Réunion',               // 974
  FRY50: 'Mayotte',                  // 976
};

const COUNTRY_BY_ISO = new Map(COUNTRIES.map((c) => [c.value, c.label]));
const DEPT_NAME_BY_CODE = new Map(
  DEPARTMENTS.map((d) => [d.value, d.label.includes(' - ') ? d.label.split(' - ')[1] : d.label]),
);

/** ISO3 → nom de pays (ex. "FRA" → "France"). Repli : le code lui-même. */
export function countryLabel(iso3?: string | null): string {
  if (!iso3) return '';
  return COUNTRY_BY_ISO.get(iso3.toUpperCase()) ?? iso3;
}

/** Code département → nom (ex. "33" → "Gironde"). Repli : le code lui-même. */
export function departmentLabel(code?: string | null): string {
  if (!code) return '';
  return DEPT_NAME_BY_CODE.get(code.toUpperCase()) ?? code;
}

/**
 * Editable labels loaded from the backend (company + global), hydrated once at
 * app start. They take priority over the static dictionary so teams can
 * complete/override labels (notably NUTS3) without a code change.
 */
let dynamicNutsLabels: Record<string, string> = {};
export function setDynamicNutsLabels(map: Record<string, string>): void {
  dynamicNutsLabels = map || {};
}

/** Code NUTS → nom : libellé éditable > dictionnaire intégré > le code lui-même. */
export function nutsRegionLabel(code?: string | null): string {
  if (!code) return '';
  const c = code.toUpperCase();
  return dynamicNutsLabels[c] ?? NUTS_REGION_LABELS[c] ?? code;
}

/** Options NUTS pour les <select> d'édition : { code, label } triées par libellé. */
export const NUTS1_OPTIONS = Object.entries(NUTS_REGION_LABELS)
  .filter(([code]) => code.length === 3)
  .map(([code, label]) => ({ code, label }))
  .sort((a, b) => a.label.localeCompare(b.label));

export const NUTS2_OPTIONS = Object.entries(NUTS_REGION_LABELS)
  .filter(([code]) => code.length === 4)
  .map(([code, label]) => ({ code, label }))
  .sort((a, b) => a.label.localeCompare(b.label));

export const NUTS3_OPTIONS = Object.entries(NUTS_REGION_LABELS)
  .filter(([code]) => code.length === 5)
  .map(([code, label]) => ({ code, label }))
  .sort((a, b) => a.label.localeCompare(b.label));

/** Unit labels for display */
export const UNIT_OPTIONS: { value: string; label: string }[] = [
  { value: 'colis', label: 'Colis' },
  { value: 'bouteille', label: 'Bouteille' },
  { value: 'palette', label: 'Palette' },
  { value: 'kg', label: 'Kilogramme (kg)' },
  { value: 'pcs', label: 'Pieces (pcs)' },
  { value: 'm3', label: 'Metre cube (m3)' },
  { value: 't', label: 'Tonne (t)' },
  { value: 'pal', label: 'Palette (pal)' },
];
